import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { CheckCircle2 } from 'lucide-react';
const PURCHASES = [{
  name: 'Valentina',
  location: 'Buenos Aires, Argentina'
}, {
  name: 'Carlos',
  location: 'Bogotá, Colombia'
}, {
  name: 'Lucía',
  location: 'Lima, Perú'
}, {
  name: 'Diego',
  location: 'Santiago, Chile'
}, {
  name: 'María',
  location: 'Ciudad de México, México'
}, {
  name: 'Juan',
  location: 'Quito, Ecuador'
}, {
  name: 'Sofía',
  location: 'Montevideo, Uruguay'
}, {
  name: 'Andrés',
  location: 'Medellín, Colombia'
}, {
  name: 'Camila',
  location: 'Guadalajara, México'
}, {
  name: 'Mateo',
  location: 'Córdoba, Argentina'
}];
export function SocialProofPopup() {
  const [isVisible, setIsVisible] = useState(false);
  const [currentPurchase, setCurrentPurchase] = useState(PURCHASES[0]);
  useEffect(() => {
    const showPopup = () => {
      const randomPurchase = PURCHASES[Math.floor(Math.random() * PURCHASES.length)];
      setCurrentPurchase(randomPurchase);
      setIsVisible(true);
      // Hide after 4 seconds
      setTimeout(() => {
        setIsVisible(false);
      }, 4000);
    };
    // Initial delay
    const initialTimeout = setTimeout(showPopup, 5000);
    // Repeat every 15-20 seconds
    const interval = setInterval(() => {
      showPopup();
    }, 20000);
    return () => {
      clearTimeout(initialTimeout);
      clearInterval(interval);
    };
  }, []);
  return <AnimatePresence data-id="element-122">
      {isVisible && <motion.div initial={{
      opacity: 0,
      y: 50,
      x: -20
    }} animate={{
      opacity: 1,
      y: 0,
      x: 0
    }} exit={{
      opacity: 0,
      y: 20
    }} className="fixed bottom-4 left-4 z-40 max-w-xs w-full" data-id="element-123">
          <div className="bg-white rounded-lg shadow-lg p-4 border-l-4 border-green-500 flex items-start gap-3" data-id="element-124">
            <div className="bg-green-100 p-2 rounded-full flex-shrink-0" data-id="element-125">
              <CheckCircle2 className="w-5 h-5 text-green-600" data-id="element-126" />
            </div>
            <div data-id="element-127">
              <p className="text-sm font-bold text-gray-900" data-id="element-128">
                {currentPurchase.name} acaba de comprar
              </p>
              <p className="text-xs text-gray-500" data-id="element-129">
                {currentPurchase.location}
              </p>
              <p className="text-xs text-green-600 font-medium mt-1" data-id="element-130">
                Hace unos instantes
              </p>
            </div>
          </div>
        </motion.div>}
    </AnimatePresence>;
}